import React from 'react'
import Icon1 from '../images/Icon1.svg'
import Icon2 from '../images/Icon2.svg'
import Icon3 from '../images/Icon3.svg'
import Icon4 from '../images/Icon4.svg'
import Icon5 from '../images/Icon5.svg'
import Icon6 from '../images/Icon6.svg'
import Icon7 from '../images/Icon7.svg'
import Icon8 from '../images/Icon8.svg'
import Icon9 from '../images/Icon9.svg'
import Icon10 from '../images/Icon10.svg'
import Icon11 from '../images/Icon11.svg'
import Icon12 from '../images/Icon12.svg'
import Icon13 from '../images/Icon13.svg'
import Icon14 from '../images/Icon14.svg'


import {MateriContainer, MateriWrapper, MateriWrapperA, MateriH1, MateriP, MateriCard, MateriIcon, MateriH2} from './MateriElements'

  
const Materi = () => {
    
  return (
    <MateriContainer id="materi">
        <MateriH1 id="materiA">List Materi AED-A</MateriH1>
        <MateriWrapperA>
            <MateriCard onClick={() => window.open( 'https://intip.in/PraktikumAEDA')}>
                <MateriIcon src={Icon1}/>
                    <MateriH2>Kelas A</MateriH2>
                    <MateriP>Materi Kelas A (Redirect ke notion)</MateriP>
            </MateriCard>
        </MateriWrapperA>
        <MateriH1 id="materiB">List Materi AED-B</MateriH1>
        <MateriWrapper>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1CewtlcKQf4LlRj-DdsjEZlMCApMdl1-h?usp=sharing')}>
                <MateriIcon src={Icon1}/>
                    <MateriH2>Week 1</MateriH2>
                    <MateriP>Data Management in Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1Z_ji7uvIq29Dt_yPgWfVIsGcGjg0DRZb?usp=sharing')}>
                <MateriIcon src={Icon2}/>
                    <MateriH2>Week 2</MateriH2>
                    <MateriP>Pie Chart, Histogram, Bar Plot and Stem n Leaf in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1CNwRa0YGnMMRx-x8zc6wrB75J96Tzwiq?usp=sharing')}>
                <MateriIcon src={Icon3}/>
                    <MateriH2>Week 3</MateriH2>
                    <MateriP>ScatterPlot and Boxplot in Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1aXfXdqD1nNFtjLaM2UM9N21IEz4luWhm?usp=sharing')}>
                <MateriIcon src={Icon4}/>
                    <MateriH2>Week 4</MateriH2>
                    <MateriP>Phi Coefficient, Cramer's V, Contingency Coefficient, Correlation Coefficient and Visualization in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1neaXYw6H2NJDi3N6uSOcEpgBkVaDP0h9?usp=sharing')}>
                <MateriIcon src={Icon5}/>
                    <MateriH2>Week 5</MateriH2>
                    <MateriP>Boxplot and Letter Values Display (Plot) in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1LGjzh_MGlQjp3-juZzzjCCOkgLQthJq0?usp=sharing')}>
                <MateriIcon src={Icon6}/>
                    <MateriH2>Week 6</MateriH2>
                    <MateriP>Resistant Line in Excel, Spreadsheet, Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1vNra8AoiyN8nS0d_WfDpr5ynXS7nVAAK?usp=sharing')}>
                <MateriIcon src={Icon7}/>
                    <MateriH2>Week 7</MateriH2>
                    <MateriP>Median Polish and Rootogram in Minitab, Excel and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/13iODEyueAnCtUlkxown5Zd2Jxli5X5Md?usp=sharing')}>
                <MateriIcon src={Icon8}/>
                    <MateriH2>Week 8</MateriH2>
                    <MateriP>Mid-term Evaluation</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1LEeYyhHdxcznQsK9qylYeqtihOX8mN8-?usp=sharing')}>
                <MateriIcon src={Icon9}/>
                    <MateriH2>Week 9</MateriH2>
                    <MateriP>Kernel Density Estimation in R (Using ggplot library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1N1CYh0pRGW2w4xxlnx2256UhlsblTH_O?usp=sharing')}>
                <MateriIcon src={Icon10}/>
                    <MateriH2>Week 10</MateriH2>
                    <MateriP>Boxplot In R (Using ggplot2 library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1CC0KUf8B-YgKr6iOwkNb85WJ-XP9YzkA?usp=sharing')}>
                <MateriIcon src={Icon11}/>
                    <MateriH2>Week 11</MateriH2>
                    <MateriP>Violin Plot In R (Using vioplot and ggplot2 library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/125ka7cqD2v0vOOmy50M_xkS55L0OGlP7?usp=sharing')}>
                <MateriIcon src={Icon12}/>
                    <MateriH2>Week 12</MateriH2>
                    <MateriP>ScatterPlot and Jitter Plot in R (Using ggplot2 and corrplot)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1gRl-ClrA_BArezUs4Iw0kCMTPpS53fJP?usp=sharing')}>
                <MateriIcon src={Icon13}/>
                    <MateriH2>Week 13</MateriH2>
                    <MateriP>Countplot and Bubble Plot in R (using ggplot2 and kaggle notebook)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/11H_NYWMV63Ro-AQpOoXIrjWQkLXBTXnY?usp=sharing')}>
                <MateriIcon src={Icon14}/>
                    <MateriH2>Week 14</MateriH2>
                    <MateriP>Animated Plot and Discuss About Final Project.</MateriP>
            </MateriCard>
        </MateriWrapper>
        <MateriH1 id="materiC">List Materi AED-C</MateriH1>
        <MateriWrapperA>
            <MateriCard onClick={() => window.open( 'https://intip.in/PraktikumAedC')}>
                <MateriIcon src={Icon1}/>
                    <MateriH2>Kelas C</MateriH2>
                    <MateriP>Materi Kelas C (Redirect ke notion)</MateriP>
            </MateriCard>
        </MateriWrapperA>
        <MateriH1 id="materiD">List Materi AED-D</MateriH1>
        <MateriWrapper>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1kU6RMgkl5e2ppwmCoo3U9UVMZxFIiqsL')}>
                <MateriIcon src={Icon1}/>
                    <MateriH2>Week 1</MateriH2>
                    <MateriP>Data Management in Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1vkSsmFi7vNyvO3cx2zEX1gUr0IIcjiyK')}>
                <MateriIcon src={Icon2}/>
                    <MateriH2>Week 2</MateriH2>
                    <MateriP>Pie Chart, Histogram, Bar Plot and Stem n Leaf in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1kJNePc3F7b7x2kJzUbCxQJucx_RFczl1')}>
                <MateriIcon src={Icon3}/>
                    <MateriH2>Week 3</MateriH2>
                    <MateriP>ScatterPlot and Boxplot in Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1Jr1mSiQIePynOhjkdqDyAnSYLaizdtbU')}>
                <MateriIcon src={Icon4}/>
                    <MateriH2>Week 4</MateriH2>
                    <MateriP>Phi Coefficient, Cramer's V, Contingency Coefficient, Correlation Coefficient and Visualization in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1HldKDqVKu10fBYdbXUL6QD7XxFvP5KOd')}>
                <MateriIcon src={Icon5}/>
                    <MateriH2>Week 5</MateriH2>
                    <MateriP>Boxplot and Letter Values Display (Plot) in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1NR4_5jjaiuHA6Ok_egzgTEtASzldaxgg')}>
                <MateriIcon src={Icon6}/>
                    <MateriH2>Week 6</MateriH2>
                    <MateriP>Resistant Line in Excel, Spreadsheet, Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon7}/>
                    <MateriH2>Week 7</MateriH2>
                    <MateriP>Median Polish and Rootogram in Minitab, Excel and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon8}/>
                    <MateriH2>Week 8</MateriH2>
                    <MateriP>Mid-term Evaluation</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon9}/>
                    <MateriH2>Week 9</MateriH2>
                    <MateriP>Kernel Density Estimation in R (Using ggplot library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon10}/>
                    <MateriH2>Week 10</MateriH2>
                    <MateriP>Boxplot In R (Using ggplot2 library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon11}/>
                    <MateriH2>Week 11</MateriH2>
                    <MateriP>Violin Plot In R (Using vioplot and ggplot2 library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon12}/>
                    <MateriH2>Week 12</MateriH2>
                    <MateriP>ScatterPlot and Jitter Plot in R (Using ggplot2 and corrplot)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon13}/>
                    <MateriH2>Week 13</MateriH2>
                    <MateriP>Countplot and Bubble Plot in R (using ggplot2 and kaggle notebook)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon14}/>
                    <MateriH2>Week 14</MateriH2>
                    <MateriP>Animated Plot and Discuss About Final Project.</MateriP>
            </MateriCard>
        </MateriWrapper>
        <MateriH1 id="materiIUP">List Materi AED-IUP</MateriH1>
        <MateriWrapper>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1kU6RMgkl5e2ppwmCoo3U9UVMZxFIiqsL')}>
                <MateriIcon src={Icon1}/>
                    <MateriH2>Week 1</MateriH2>
                    <MateriP>Data Management in Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1vkSsmFi7vNyvO3cx2zEX1gUr0IIcjiyK')}>
                <MateriIcon src={Icon2}/>
                    <MateriH2>Week 2</MateriH2>
                    <MateriP>Pie Chart, Histogram, Bar Plot and Stem n Leaf in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1kJNePc3F7b7x2kJzUbCxQJucx_RFczl1')}>
                <MateriIcon src={Icon3}/>
                    <MateriH2>Week 3</MateriH2>
                    <MateriP>ScatterPlot and Boxplot in Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1Jr1mSiQIePynOhjkdqDyAnSYLaizdtbU')}>
                <MateriIcon src={Icon4}/>
                    <MateriH2>Week 4</MateriH2>
                    <MateriP>Phi Coefficient, Cramer's V, Contingency Coefficient, Correlation Coefficient and Visualization in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1HldKDqVKu10fBYdbXUL6QD7XxFvP5KOd')}>
                <MateriIcon src={Icon5}/>
                    <MateriH2>Week 5</MateriH2>
                    <MateriP>Boxplot and Letter Values Display (Plot) in R and Minitab</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1NR4_5jjaiuHA6Ok_egzgTEtASzldaxgg')}>
                <MateriIcon src={Icon6}/>
                    <MateriH2>Week 6</MateriH2>
                    <MateriP>Resistant Line in Excel, Spreadsheet, Minitab and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon7}/>
                    <MateriH2>Week 7</MateriH2>
                    <MateriP>Median Polish and Rootogram in Minitab, Excel and R</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon8}/>
                    <MateriH2>Week 8</MateriH2>
                    <MateriP>Mid-term Evaluation</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon9}/>
                    <MateriH2>Week 9</MateriH2>
                    <MateriP>Kernel Density Estimation in R (Using ggplot library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon10}/>
                    <MateriH2>Week 10</MateriH2>
                    <MateriP>Boxplot In R (Using ggplot2 library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon11}/>
                    <MateriH2>Week 11</MateriH2>
                    <MateriP>Violin Plot In R (Using vioplot and ggplot2 library)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon12}/>
                    <MateriH2>Week 12</MateriH2>
                    <MateriP>ScatterPlot and Jitter Plot in R (Using ggplot2 and corrplot)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon13}/>
                    <MateriH2>Week 13</MateriH2>
                    <MateriP>Countplot and Bubble Plot in R (using ggplot2 and kaggle notebook)</MateriP>
            </MateriCard>
            <MateriCard onClick={() => window.open( 'https://drive.google.com/drive/folders/1nBmaokbvR9D0baj6jxjsgDg9dQlEbWrk')}>
                <MateriIcon src={Icon14}/>
                    <MateriH2>Week 14</MateriH2>
                    <MateriP>Animated Plot and Discuss About Final Project.</MateriP>
            </MateriCard>
        </MateriWrapper>
    </MateriContainer>
  )
}

export default Materi